import { render, staticRenderFns } from "./ion-date-picker.vue?vue&type=template&id=6fba2488"
import script from "./ion-date-picker.vue?vue&type=script&lang=js"
export * from "./ion-date-picker.vue?vue&type=script&lang=js"
import style0 from "./ion-date-picker.vue?vue&type=style&index=0&id=6fba2488&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports